var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExchangeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "#959595",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x33_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.5184 12.9443C15.488 13.0184 15.5527 15.0925 13.5407 15.0925H5.11834C3.15104 15.0925 3.17224 13.0707 3.14062 12.9961C15.9594 12.9807 15.3091 13.0393 15.5184 12.9443Z",
    fill: "#959595"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.427063 3.49059C0.427063 2.06096 1.5899 0.890625 3.01966 0.890625H8.57521V11.498H3.01966C1.5899 11.498 0.427063 10.3351 0.427063 8.89803V3.49059ZM5.33118 8.04261V4.40625H4.60853L3.70831 4.97621V5.65803L4.54105 5.13601H4.56236V8.04261H5.33118Z",
    fill: "#959595"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.074 0.907471H15.622C17.0518 0.907471 18.2222 2.07781 18.2222 3.50743V8.91488C18.2222 10.3519 17.0518 11.5148 15.622 11.5148H10.074V0.907471ZM12.8844 7.26497V7.81894H15.4768V7.19039H13.9498V7.16553L14.4807 6.64529C14.7304 6.41802 14.924 6.2233 15.0613 6.06113C15.1986 5.89778 15.2939 5.74922 15.3471 5.61546C15.4016 5.4817 15.4288 5.34617 15.4288 5.20886C15.4288 4.99934 15.375 4.8135 15.2672 4.65133C15.1595 4.48916 15.0086 4.3625 14.8145 4.27136C14.6215 4.17903 14.3948 4.13286 14.1344 4.13286C13.8811 4.13286 13.6574 4.1808 13.4633 4.27669C13.2691 4.37257 13.1182 4.5081 13.0105 4.68329C12.9028 4.85848 12.8489 5.06504 12.8489 5.30296H13.5787C13.5787 5.18696 13.6012 5.08694 13.6462 5.00289C13.6911 4.91885 13.7551 4.85434 13.8379 4.80936C13.9208 4.76437 14.0178 4.74188 14.1291 4.74188C14.2356 4.74188 14.3309 4.76319 14.415 4.8058C14.499 4.84723 14.5653 4.90701 14.6138 4.98514C14.6624 5.06208 14.6866 5.15382 14.6866 5.26035C14.6866 5.35623 14.6671 5.4456 14.628 5.52846C14.589 5.61014 14.5316 5.69359 14.4558 5.77882C14.3812 5.86404 14.2889 5.95992 14.1788 6.06646L12.8844 7.26497Z",
    fill: "#959595"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchangeIcon);
export default __webpack_public_path__ + "static/media/exchange-icon.a5d055f869698392200ac5f0e96443bc.svg";
export { ForwardRef as ReactComponent };